import { buildRomajiMap, convertRomajiSentence } from "./romajiConverter";
import { hiraganas } from "../consts/hiraganaList";

export interface JapaneseRomajiPreview {
    hiragana: string;
    fullyResolved: boolean;
}

interface RomajiSegment {
    text: string;
    converted: boolean;
    correction?: { correct: string; note: string };
}

const LATIN_LETTER_PATTERN = /[a-zA-Z]/;
const EMAIL_PATTERN = /[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}/;
const URL_PATTERN = /https?:\/\/\S+|www\.[a-z0-9-]+\.[a-z]{2,}\S*/i;

let hiraganaRomajiMap: Record<string, string> | null = null;

function getHiraganaRomajiMap(): Record<string, string> {
    if (!hiraganaRomajiMap) hiraganaRomajiMap = buildRomajiMap(hiraganas) as Record<string, string>;
    return hiraganaRomajiMap;
}

export function getJapaneseRomajiPreview(text: string): JapaneseRomajiPreview | null {
    if (!LATIN_LETTER_PATTERN.test(text) || EMAIL_PATTERN.test(text) || URL_PATTERN.test(text)) return null;

    const segments = convertRomajiSentence(text, getHiraganaRomajiMap(), false) as RomajiSegment[];
    const hiragana = segments.map((segment) => segment.correction?.correct ?? segment.text).join("");
    if (hiragana === text) return null;

    const fullyResolved = segments.every((segment) => segment.converted);
    return { hiragana, fullyResolved };
}
